import { cx } from '@linaria/core';
import { PM2DisplayProvider } from '@pm2/store';
import { containerCls, mediaCls } from './richtext-media.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function RichTextMedia(props) {
  return /*#__PURE__*/jsxs("div", {
    className: containerCls,
    children: [/*#__PURE__*/jsx("div", {
      className: cx(mediaCls, props.align),
      children: /*#__PURE__*/jsx(PM2DisplayProvider, {
        inGrid: true,
        children: props.children.media
      })
    }), props.children.children]
  });
}

export { RichTextMedia };
//# sourceMappingURL=richtext-media.js.map
